<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Sucursales del sistema </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text mr-2" @click="editItem()">
              <v-icon small class="">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
            <v-btn class="orange darken-2 white--text" @click="openSincronizar()">
              <v-icon small class="mr-2">
                mdi-plus
              </v-icon>
              Sincronizar
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.is_directo`]="{ item }">
          <span> {{ item.is_directo ? 'SI' : 'NO' }} </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="editItem(item)">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>Editar Sucursal</span>
          </v-tooltip>

          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>Agregar Punto de venta</span>
          </v-tooltip> -->

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="!item.iselectronica" small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="verpuntos(item)">
                  mdi-briefcase-download
                </v-icon>
              </v-btn>
            </template>
            <span>Ver/Agregar Punto de venta</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="versedes(item)">
                  mdi-eye
                </v-icon>
              </v-btn>
            </template>
            <span>Ver sedes {{ item.id }} </span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="dosificaciones(item)">
                  mdi-flask-plus
                </v-icon>
              </v-btn>
            </template>
            <span> Dosificaciones </span>
          </v-tooltip>

          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="asignacionsedes(item)">
                  mdi-nature
                </v-icon>
              </v-btn>
            </template>
            <span>Sedes sucursal</span>
          </v-tooltip> -->
        </template>
      </v-data-table>
    </template>

    <SucursalesAM ref="unidadesam" v-on:newregsucursal="newregsucursal" />
    <SucursalesDEL ref="unidadesdel" />
    <Asignarsede ref="asignarsede" />
    <Sincronizar ref="sincronizar" />
  </div>
</template>

<script>
  import SucursalesAM from '@/views/Sucursales/Sucursalesam.vue';
  import SucursalesDEL from '@/views/Sucursales/Sucursalesdel.vue';
  import Asignarsede from '@/views/Sucursales/Asignarsede.vue';
  import Sincronizar from '@/views/Sucursales/Sincronizar.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      headers: [
        {
          text: 'Numero sucursal',
          align: 'start',
          sortable: false,
          value: 'numero_sucursal',
        },
        { text: 'Nit', value: 'nro_nit' },
        { text: 'Direccion', value: 'direccion' },
        { text: 'Factura Directo', value: 'is_directo', width: 50 },
        { text: 'Ciudad', value: 'ciudad' },
        { text: 'Municipio', value: 'municipio' },
        //{ text: 'El.', value: 'iselectronica' },
        { text: 'Opciones', value: 'actions', sortable: false, width: 150 },
        //{ text: 'Actions', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { SucursalesAM, SucursalesDEL, Asignarsede, Sincronizar },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        //let peticiones = [];
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.iselectronica = false;
              if (x.tipo_facturacion.includes('ELECTR')) {
                x.iselectronica = true;
              }
              if (x.tipo_facturacion.includes('COMPUTARIZADA EN')) {
                x.iselectronica = true;
              }
            });
            vue.desserts = data;
            vue.loading = false;
            /*vue.desserts.forEach((x) => {
              const promise = axios.get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${x.id}`);
              peticiones.push(promise);
            });*/

            /*Promise.all(peticiones)
              .then(function(values) {
                values.forEach((x) => {
                  let idsuc = x.data.id;
                  let s = vue.desserts.find((ss) => ss.id == idsuc);
                  if (s && x.data.tipo_facturacion.includes('ELECTR')) {
                    s.iselectronica = true;
                  }
                  //window.console.log(s, x.data);
                  vue.loading = false;
                });
              })
              .catch((e) => {
                window.console.error(e);
                vue.loading = false;
              });*/

            //window.console.log(response.data);
            //vue.loading = false;
          })
          .catch(function(error) {
            vue.loading = false;
            window.console.log(error);
          });
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.$refs.unidadesam.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      asignarsede(item) {
        this.$refs.asignarsede.openmodal(item);
      },

      verpuntos(item) {
        let url = `/pventas?idsucursal=${item.id}&numsucursal=${item.numero_sucursal}`;
        this.$router.push(url);
      },
      versedes(item) {
        this.$router.push('/sedesbysucursal?sucursalId=' + item.id);
      },

      asignacionsedes(item) {
        let url = `/asignacionsede?idsucursal=${item.id}`;
        this.$router.push(url);
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      newregsucursal(item) {
        window.console.log('newregsucursal', item);
        this.initialize();
      },
      openSincronizar() {
        this.$refs.sincronizar.openmodal(this.desserts);
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      dosificaciones(item) {
        let url = `/dosificacionesx?idsucursal=${item.id}`;
        this.$router.push(url);
      },
    },
  };
</script>
